(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* ---------------- Menu open behavior (hover or click) ---------------- */
  document.addEventListener('DOMContentLoaded', function () {
    var headerWrapper = document.querySelector('.header-wrapper');
    var menuOpenOn = headerWrapper ? headerWrapper.dataset.menuOpenOn : 'hover';
    var secondMenu = document.querySelector('.header-second-menu');
    var mainHeader = document.querySelector('header.header');
    var menuContainers = [secondMenu, mainHeader].filter(Boolean);

    function enableHoverMenus(container) {
      if (!container) return;
      var detailsList = container.querySelectorAll('header-menu details');

      detailsList.forEach(function (details) {
        var closeTimer;

        details.addEventListener('mouseenter', function () {
          if (window.matchMedia('(min-width: 990px)').matches) {
            clearTimeout(closeTimer);
            details.setAttribute('open', '');
          }
        });

        details.addEventListener('mouseleave', function () {
          if (window.matchMedia('(min-width: 990px)').matches) {
            closeTimer = setTimeout(function () {
              details.removeAttribute('open');
            }, 150);
          }
        });
      });
    }

    function enableClickMenus(container) {
      if (!container) return;

      container.querySelectorAll('details').forEach(function (details) {
        details.addEventListener('toggle', function () {
          if (!details.open || !window.matchMedia('(min-width: 990px)').matches) return;

          var parentMenu = details.parentElement.closest('header-menu');
          if (parentMenu && details.parentElement === parentMenu) {
            parentMenu.querySelectorAll(':scope > details[open]').forEach(function (sibling) {
              if (sibling !== details) sibling.removeAttribute('open');
            });
            return;
          }

          var parentList = details.closest('ul');
          if (!parentList) return;

          parentList.querySelectorAll(':scope > li > details[open]').forEach(function (sibling) {
            if (sibling !== details) sibling.removeAttribute('open');
          });
        });
      });
    }

    if (menuOpenOn === 'hover') {
      menuContainers.forEach(enableHoverMenus);
    } else {
      menuContainers.forEach(enableClickMenus);

      document.addEventListener('click', function (event) {
        if (!window.matchMedia('(min-width: 990px)').matches) return;

        menuContainers.forEach(function (container) {
          if (container.contains(event.target)) return;

          container.querySelectorAll('details[open]').forEach(function (details) {
            details.removeAttribute('open');
          });
        });
      });
    }

    document.querySelectorAll('summary.header__menu-item--parent').forEach(function (summary) {
      summary.addEventListener('pointerdown', function (event) {
        if (event.target.closest('.header__menu-item-link')) {
          event.preventDefault();
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
